import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api, fileUrl } from "../lib/api";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { Button } from "../components/ui/button";
import { ArrowLeft, Calendar } from "lucide-react";

const fmtDate = (iso) => { try { return new Date(iso).toLocaleDateString("pt-PT", { day: "2-digit", month: "long", year: "numeric" }); } catch { return ""; } };
const ytId = (url) => { const m = url && url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([\w-]{11})/); return m ? m[1] : null; };

export default function BlogPost() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => { api.get(`/posts/${id}`).then((r) => setPost(r.data)).catch(() => setNotFound(true)); }, [id]);

  if (notFound) {
    return (
      <div className="App"><Navbar />
        <div className="pt-40 pb-40 text-center">
          <h1 className="font-heading font-bold text-3xl">Artigo não encontrado</h1>
          <Button onClick={() => navigate("/blog")} className="mt-6 rounded-full bg-primary text-primary-foreground">Voltar ao Blog</Button>
        </div>
        <Footer />
      </div>
    );
  }
  if (!post) return <div className="App"><Navbar /><div className="pt-40 flex justify-center"><div className="w-10 h-10 border-2 border-primary border-t-transparent rounded-full animate-spin" /></div></div>;

  const vid = ytId(post.video_url);

  return (
    <div className="App">
      <Navbar />
      <article className="max-w-3xl mx-auto px-5 sm:px-8 pt-[112px] pb-24">
        <button data-testid="blog-back" onClick={() => navigate("/blog")} className="flex items-center gap-2 text-sm font-semibold text-muted-foreground hover:text-foreground transition-colors mb-6">
          <ArrowLeft className="w-4 h-4" /> Voltar ao Blog
        </button>
        <p className="text-xs text-muted-foreground flex items-center gap-1.5"><Calendar className="w-3.5 h-3.5 text-primary" /> {fmtDate(post.created_at)}</p>
        <h1 className="font-heading font-black text-4xl sm:text-5xl tracking-tighter mt-3 mb-6">{post.title}</h1>

        {vid ? (
          <div className="rounded-3xl overflow-hidden aspect-video mb-8 bg-black">
            <iframe data-testid="blog-video-embed" title={post.title} src={`https://www.youtube.com/embed/${vid}`} className="w-full h-full" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
          </div>
        ) : post.cover ? (
          <div className="rounded-3xl overflow-hidden aspect-video mb-8 bg-muted">
            <img src={fileUrl(post.cover)} alt={post.title} className="w-full h-full object-cover" />
          </div>
        ) : null}

        {post.excerpt && <p className="text-lg text-foreground font-medium mb-5">{post.excerpt}</p>}
        <div className="text-muted-foreground leading-relaxed whitespace-pre-line">{post.content}</div>
      </article>
      <Footer />
    </div>
  );
}
